import React, { Component } from 'react';
import throttle from 'lodash.throttle';
import PropTypes from 'prop-types';
import { Helmet } from 'react-helmet';
import { connect } from 'react-redux';
import { withRouter, Link } from 'react-router-dom';
import { isSupportedFeature, constants as features } from '@saucelabs/sl-component-supported-feature';
import { actions as jobsActions } from '@saucelabs/sl-module-jobs';
import { TitleRow } from '@saucelabs/sl-component-breadcrumbs';
import Button from '@saucelabs/sl-component-buttons';

import {
  CONFIGURATION_TEST_TYPES,
  JOBS_UI_ELEMENTS,
  NAVIGATION_EVENTS,
  trackEvent,
} from './../tracking';
import { constants as sharedConstants } from './../ducks/shared';
import { actions, selectors, utils } from './../ducks/flatManual';
import ManualJobsTab from './../components/ManualJobsTab';
import Styles from './FlatManualJobsContainer.styles';

const crumbsList = [
  { name: 'Live' }, { name: 'Test Results' },
];

class FlatManualJobsContainer extends Component {
  constructor(props) {
    super(props);
    this.pollers = [];
    this.throttledFetchData = throttle(this.fetchData, sharedConstants.API_FETCH_THROTTLE);
    this.fetchData();
  }

  componentWillUnmount() {
    const { cleanup } = this.props;
    this.pollers.forEach(clearInterval);
    cleanup();
  }

  callAPIWithIntervals(apiCalls) {
    this.pollers.forEach(clearInterval);
    apiCalls.forEach((apiCall) => apiCall());
    this.pollers = apiCalls.map((apiCall) => (
      setInterval(() => apiCall(), sharedConstants.API_FETCH_INTERVAL)
    ));
  }

  fetchData() {
    const { getManualJobs, username } = this.props;
    // fetch tab specific data when tab is activated
    const pollers = [];
    const params = utils.manualJobQueryParams({ username });
    pollers.push(() => getManualJobs(params));

    this.callAPIWithIntervals(pollers);
  }

  render() {
    const { isOpenSauceUser, isManualJobsListEmpty } = this.props;

    const trackEventMetadataState = !isManualJobsListEmpty ? 'With Jobs State' : 'Empty State';
    const showSeeAllButton = isSupportedFeature(features.ARCHIVES) && !isOpenSauceUser;
    return (
      <div
        className={Styles.wrapper}
        data-qa="live-jobs-container"
      >
        <Helmet>
          <title>Manual | Test Results</title>
        </Helmet>
        <TitleRow list={crumbsList}>
          {!isOpenSauceUser && (
            <div className={Styles['new-test-wrapper']}>
              <Link
                onClick={() => trackEvent(
                  NAVIGATION_EVENTS.MANUAL_JOB,
                  {
                    testType: CONFIGURATION_TEST_TYPES.WEB,
                    state: trackEventMetadataState,
                    target: JOBS_UI_ELEMENTS.NEW_WEB_TEST_BUTTON_BREADCRUMB,
                  },
                )}
                to="/live/web-testing"
              >
                <Button
                  category="action"
                  className={Styles['new-test-wrapper-button']}
                  size="sm"
                >
                  New Live Web Test
                </Button>
              </Link>
              <Link
                onClick={() => trackEvent(
                  NAVIGATION_EVENTS.MANUAL_JOB,
                  {
                    testType: CONFIGURATION_TEST_TYPES.APP,
                    state: trackEventMetadataState,
                    target: JOBS_UI_ELEMENTS.NEW_APP_TEST_BUTTON_BREADCRUMB,
                  },
                )}
                to="/live/app-testing"
              >
                <Button
                  category="action"
                  size="sm"
                >
                  New Live App Test
                </Button>
              </Link>
            </div>
          )}
        </TitleRow>
        <ManualJobsTab
          isOpenSauceUser={isOpenSauceUser}
          showSeeAllButton={showSeeAllButton}
        />
      </div>
    );
  }
}

FlatManualJobsContainer.propTypes = {
  cleanup: PropTypes.func.isRequired,
  getManualJobs: PropTypes.func.isRequired,
  isManualJobsListEmpty: PropTypes.bool,
  isOpenSauceUser: PropTypes.bool,
  username: PropTypes.string.isRequired,
};

FlatManualJobsContainer.defaultProps = {
  isManualJobsListEmpty: true,
  isOpenSauceUser: false,
};

const mapStateToProps = selectors.containerSelector;
const mapDispatchToProps = {
  cleanup: actions.cleanup,
  getManualJobs: jobsActions.getManualJobs,
};

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps,
  )(FlatManualJobsContainer),
);
export { FlatManualJobsContainer };
